import type { MonthlyBreakdownReportDto, CountPercentRowDto, MonthKey } from './MonthlyBreakdownReportDto';

import type { MonthlyBreakdownReport, CountPercentRow } from 'model/BookingsMonthlyBreakdownReport';

const MONTH_KEYS: MonthKey[] = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

const convertCountPercentRow = (row: CountPercentRowDto): CountPercentRow => {
    const values = MONTH_KEYS.reduce((acc, k) => {
        acc[k] = { value: row[k].value, pct: row[k].pct };
        return acc;
    }, {} as CountPercentRow['values']);

    return {
        values,
        total: row.total
    };
};

export const convertToMonthlyBreakdownReport = (dto: MonthlyBreakdownReportDto): MonthlyBreakdownReport => {
    return {
        year: dto.year,

        totalBookings: dto.total_bookings,
        totalClients: dto.total_clients,
        totalPets: dto.total_pets,

        totalServices: dto.total_services,
        totalAddons: dto.total_addons,
        totalProducts: dto.total_products,
        totalCustomItems: dto.total_custom_items,

        completed: convertCountPercentRow(dto.completed),
        canceled: convertCountPercentRow(dto.canceled),
        noShow: convertCountPercentRow(dto.no_show),

        netSales: dto.net_sales
    };
};
